import { CIcon } from '~/icons/types'
export const ciAudit: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M12.53 12.651a.998.998 0 0 0-1.378.317L9.4 15.772l-1.119-1.398a.999.999 0 1 0-1.561 1.25l2 2.5a1 1 0 0 0 1.628-.095l2.5-4a1 1 0 0 0-.318-1.378Z'
    },
    {
      d:
        'M18.356 2.92a46.854 46.854 0 0 0-.538-.042A3.232 3.232 0 0 0 15 1.25h-1.5c-1.188 0-2.25.632-2.819 1.628-.179.013-.359.027-.538.042-1.649.137-2.893 1.507-2.893 3.188V7.25H4.875A2.127 2.127 0 0 0 2.75 9.375v11.25c0 1.172.953 2.125 2.125 2.125h9.75a2.127 2.127 0 0 0 2.125-2.125v-.875H18a3.254 3.254 0 0 0 3.25-3.25V6.108c0-1.681-1.244-3.051-2.894-3.188ZM12.3 4.149l.011-.035A1.243 1.243 0 0 1 13.5 3.25H15c.547 0 1.022.347 1.189.864l.01.033a.736.736 0 0 1 .025.103h-3.95a1.15 1.15 0 0 1 .026-.101Zm2.45 16.476a.125.125 0 0 1-.125.125h-9.75a.125.125 0 0 1-.125-.125V9.375c0-.069.056-.125.125-.125h9.75c.069 0 .125.056.125.125v11.25Zm4.5-4.125c0 .689-.561 1.25-1.25 1.25h-1.25V9.375a2.127 2.127 0 0 0-2.125-2.125H9.25V6.108c0-.628.45-1.14 1.049-1.194A1.754 1.754 0 0 0 12 6.25h4.5c.822 0 1.514-.57 1.7-1.336.6.055 1.05.566 1.05 1.194V16.5Z'
    }
  ],
  name: 'audit',
  type: 'regular'
}
